export default __webpack_public_path__ + "static/media/sliced.f978ee9c.svg";